import { render, staticRenderFns } from "./UseTime.vue?vue&type=template&id=64862d28&scoped=true"
import script from "./UseTime.vue?vue&type=script&lang=js"
export * from "./UseTime.vue?vue&type=script&lang=js"
import style0 from "./UseTime.vue?vue&type=style&index=0&id=64862d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64862d28",
  null
  
)

export default component.exports